import { render } from "./ViewPayment.vue?vue&type=template&id=8810268c&scoped=true"
import script from "./ViewPayment.vue?vue&type=script&lang=js"
export * from "./ViewPayment.vue?vue&type=script&lang=js"

import "./ViewPayment.vue?vue&type=style&index=0&id=8810268c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8810268c"]])

export default __exports__